import { render, staticRenderFns } from "./RedeemAmountModal.vue?vue&type=template&id=16f912b2&scoped=true&"
import script from "./RedeemAmountModal.vue?vue&type=script&lang=js&"
export * from "./RedeemAmountModal.vue?vue&type=script&lang=js&"
import style0 from "./RedeemAmountModal.vue?vue&type=style&index=0&id=16f912b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f912b2",
  null
  
)

export default component.exports